module.exports = __webpack_public_path__ + "static/media/specializes-in.1c2f6166.svg";